import React from "react";
import { Helmet } from "react-helmet";
import RandingStyle14 from "../../randing/RandingStyle14";

function Randing107({ urlCode, urlCodeSettingId, apiUrl }) {
  const propsImplantValues = {
    btn1: "비용",
    btn2: "두려움",
    btn3: "통증",
    btn4: "기타",
    btn5: "50대",
    btn6: "60대",
    btn7: "70대",
    btn8: "기타",
  };

  return (
    <>
      <Helmet>
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NMKKSSDC');
          `}
        </script>
      </Helmet>

      <div
        dangerouslySetInnerHTML={{
          __html: `
            <!-- Google Tag Manager (noscript) -->
            <noscript>
              <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NMKKSSDC"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
            </noscript>
            <!-- End Google Tag Manager (noscript) -->
          `,
        }}
      ></div>

      <RandingStyle14
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        totalStep="2"
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/107/20250228_001.png`}
        question1={`${process.env.REACT_APP_CDN_BASE}/images/107/Q1.png`}
        question2={`${process.env.REACT_APP_CDN_BASE}/images/107/Q2.png`}
        question3={`${process.env.REACT_APP_CDN_BASE}/images/107/Q3.png`}
        btnOption1={`${process.env.REACT_APP_CDN_BASE}/images/107/option1`}
        btnOption2={`${process.env.REACT_APP_CDN_BASE}/images/107/option2`}
        btnOption3={`${process.env.REACT_APP_CDN_BASE}/images/107/option3`}
        btnOption4={`${process.env.REACT_APP_CDN_BASE}/images/107/option4`}
        btnOption5={`${process.env.REACT_APP_CDN_BASE}/images/107/option5`}
        btnOption6={`${process.env.REACT_APP_CDN_BASE}/images/107/option6`}
        btnOption7={`${process.env.REACT_APP_CDN_BASE}/images/107/option7`}
        btnOption8={`${process.env.REACT_APP_CDN_BASE}/images/107/option8`}
        propsImplantValues={propsImplantValues}
        buttonGroupVer={2}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/107/postBTN.gif`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing107;
